<template>
    <div class="loading_box" @touchmove.prevent @mousewheel.prevent>
        <div class="loading_inner">
            <img src="../../assets/images/loading.gif" alt="">
        </div>
    </div>
</template>

<style lang="less" scoped>
.loading_box{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;bottom: 0;
    left: 0;right: 0;
    margin: auto;
    // background: rgba(255,255,255,1);
    z-index: 10000;
    .loading_inner{
        width: 100px;
        height: 100px;
        position: fixed;
        top: 0;bottom: 0;
        left: 0;right: 0;
        margin: auto;
        font-size: 24px;
        color: #000;
        img{
            width: 100%;
        }
    }
}

</style>

<script>
export default {
    mounted(){
        
    },
    methods: {
        
    }
}
</script>